module.exports = __webpack_public_path__ + "static/media/3d-plan_general_Archform.91197f67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/3d-plan_general_Archform.svg
// module id = 936
// module chunks = 0